
    import '/Users/lijixiang/Work/power-design/site/docs/power-design/faker-mode.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-faker-mode-demo-basic","docs-power-design-faker-mode-demo-user-switch"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/faker-mode.md?type=demo')
};